import addDays from 'date-fns/addDays';
import isWithinInterval from 'date-fns/isWithinInterval';

// Validates XXXX-XX-XX format
export const isHyphenatedYearMonthDay = dateString => /^\d{4}-\d{2}-\d{2}$/.test(dateString);

// Validates XX/XX/XXXX
export const isSlashedMonthDayYear = dateString => /^\d{2}\/\d{2}\/\d{4}$/.test(dateString);

// Converts a Date object to YYYY-MM-DD string
export const yearMonthDayIso = date => date.toISOString().substring(0, 10);

// Converts a YYYY-MM-DD string to MM/DD/YYYY string
export const monthDayYearString = dateString => {
  if (isHyphenatedYearMonthDay(dateString)) {
    const year = dateString.substring(0, 4);
    const month = dateString.substring(5, 7);
    const day = dateString.substring(8, 10);
    return `${month}/${day}/${year}`;
  }
  return null;
};

// Determine if an element is in the viewport
// @param  {Node} The DOM element
// @return {Boolean} Returns if element is in the viewport
export const isInViewport = element => {
  const distance = element.getBoundingClientRect();
  return (
    distance.top >= 0 &&
    distance.left >= 0 &&
    distance.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    distance.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

export const addressFieldName = (addressType, field) => `addresses.${addressType}.${field}`;

// EOY Date Helpers. Logic copied from ZP (end_of_year_detector.rb)
//
// How many days before 12/31 are considered "end of year"?
const END_OF_YEAR_WINDOW_START_DAYS = 91; // "end of year" starts 10/1
// How many days after 12/31 are considered "end of year"?
const END_OF_YEAR_WINDOW_END_DAYS = 0; // "end of year" ends 12/31

function endOfYear() {
  return new Date(addDays(new Date(), -END_OF_YEAR_WINDOW_END_DAYS).getFullYear(), 11, 31); // 11 is December
}

function endOfYearStartDate() {
  return addDays(endOfYear(), -END_OF_YEAR_WINDOW_START_DAYS);
}

function endOfYearEndDate() {
  return addDays(endOfYear(), END_OF_YEAR_WINDOW_END_DAYS);
}

export const isEndOfYear = () => {
  return isWithinInterval(new Date(), {
    start: endOfYearStartDate(),
    end: endOfYearEndDate(),
  });
};

export function currentYear() {
  return endOfYearStartDate().getFullYear();
}

export function newYear() {
  return currentYear() + 1;
}
